module.exports = __webpack_public_path__ + "media/images/facebook-d0043930c827470f8f8ecbef7953aa36.svg";